import ClientDashboard from 'src/layouts/ClientDashboard';
import { SIDEBAR_OPTIONS } from '@/constants/components/sidebar';
import { BacktoAllJobs, Button, ButtonStyle, clearSWRCache, cursorNone, Fb, Field, Form, Formik, FormikControl,getActiveIds, goToNextPage, getJobSharingData, handleActiveJobBoard, handleJobSharingFormSubmit, hideDraft, Image,
         imageSize, JobSharing, jobStatusBadge, JOB_STEPS, JobLivePopup, Li, motion, NextServerCookies, PAGE_ANIMATION_OPTIONS, React, socialIcons, Twi, useEffect, useQueryClient,
         useRouter, useState, useSWR, previewJob, DataFromUrl, REDIRECT, useTranslation, InputError, shouldRenderSuggestions, renderInputComponent, getUserSuggestionValue, renderUserSuggestion, onUserSuggestionsFetchRequested,
          CandidateStyle, BackArrow, ArrowLeft, UpwardArrow, SingleCandidateModal, PageStyle} from '@/imports-files/pages/clients/jobs/job-sharing';

import {CommonAction}  from "@/imports-files/common/common.js"
import { hideCompareCandidate, getScorecards, CustomToastrAction } from '@/imports-files/pages/clients/candidates/kanban';
import Tooltip from "react-simple-tooltip";
import EllipsisText from "react-ellipsis-text";


export default function CompareCandidates(props)
{
  const {t} = useTranslation()
  const { data } = props
  const [buttonPopup, setButtonPopup] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [scorecardData, setScoreCardData] = useState({});
  const commonAction = new CommonAction();
  const customToastrAction    =     new CustomToastrAction();
  const flexBasis = data.score_hash.length <= 3 ? 'flex-basis-33' : 'flex-basis-20'

  function TabletWidth(data){
    if(data.score_hash.length < 3){
      if(window.innerWidth <= 1200){
        return {minWidth: "700px"}
      }
    }
    else if(data.score_hash.length == 4){
      if(window.innerWidth <= 1200){
        return {minWidth: "900px"}
      }
    }
    return {}
  }


  function getScoreColor(score, isLight){
    let scoreValue = parseFloat(score)
    if((scoreValue == NaN) || (scoreValue == 0))
      return isLight ? CandidateStyle.BgNaLight : CandidateStyle.BgNa
    else if(scoreValue <= 2)
      return isLight ? CandidateStyle.BgRedLight : CandidateStyle.BgRed
    else if(scoreValue > 2 && scoreValue < 4)
      return isLight ? CandidateStyle.BgYellowLight : CandidateStyle.BgYellow
    else if(scoreValue >= 4)
      return isLight ? CandidateStyle.BgGreenLight : CandidateStyle.BgGreen
    else
      return isLight ? CandidateStyle.BgNaLight : CandidateStyle.BgNa
  }

  return (
    <div className={`DashboardPageContent ${CandidateStyle.CompareCandidates}`}>
        <motion.div initial="pageInitial"  animate="pageAnimate"  exit="pageExit"  variants={PAGE_ANIMATION_OPTIONS}  transition={{ delay: 0.2}}>
          <div className = {`${PageStyle.ClientCompany__BackSection}`}>
              <span onClick={() => hideCompareCandidate()}>
                <ArrowLeft />
                <span>{t('compare_candidate:back_to_kanban')}</span>
              </span>
          </div>
          <div className = {`${CandidateStyle.PageTitle}`}>
            <h4>{t('compare_candidate:title')}</h4>
            <h1 className = {`${CandidateStyle.CompareCandidates__JobName} ${PageStyle.LightBlueColor}`}>
              {data.job_title}
            </h1>
          </div>
          <div className = {`${CandidateStyle.CompareCandidates__CandidateDetails}`}>
              <div className = {`${CandidateStyle.CompareCandidates__LeftContent}`}>
                  <div className = {`${CandidateStyle.CompareCandidates__Label}`}>
                      <h3>{t('compare_candidate:candidate')}</h3>
                  </div>
                  <div className = {`${CandidateStyle.CompareCandidates__Reviewers}`}>
                      <h3>{t('compare_candidate:reviewers')}</h3>
                  </div>
                  <div className = {`${CandidateStyle.CompareCandidates__Feedback}`}>
                      <h3>{t('compare_candidate:feedback')}</h3>
                  </div>
                  <div className = {`${CandidateStyle.CompareCandidates__OverallScore}`}>
                      <h3>{t('compare_candidate:overall_score')}</h3>
                  </div>
              </div>
              <div className = {`${CandidateStyle.CompareCandidates__RightContent}`}>
                  <div className = {`${CandidateStyle.CompareCandidates__CandidateName}`} style={TabletWidth(data)}>
                      {data.score_hash.map((candidate, index) =>
                        <h3 className={`${flexBasis}`}><span onClick={async() => {
                          let scoredcards = await getScorecards(candidate.job_application_id)
                          if(scoredcards){
                            setScoreCardData(scoredcards);
                            setButtonPopup(true);
                          }
                          else{
                            customToastrAction.setNormalToastr(`${t('compare_candidate:scorecard_not_available')} ${candidate.candidate_name}.`, 'warning');
                          }
                        }}>{candidate.candidate_name} <UpwardArrow/> </span></h3>
                      )}
                  </div>
                  <div className = {`${CandidateStyle.CompareCandidates__ReviewersCount}`} style={TabletWidth(data)}>
                      {data.score_hash.map((candidate, index) =>
                        <h3 className={`${flexBasis}`}>{`${candidate.reviewer}`} {t('compare_candidate:reviewers')}</h3>
                      )}
                  </div>
                  <div className = {`${CandidateStyle.CompareCandidates__FeedbackCount}`} style={TabletWidth(data)}>
                      {data.score_hash.map((candidate, index) =>
                        <h3 className={`${flexBasis} ${candidate.notes > 0 ? 'td-underline CursorPointer': ''}`} onClick={async() => {
                          let scoredcards = await getScorecards(candidate.job_application_id)
                          if(scoredcards){
                            setScoreCardData(scoredcards);
                            setButtonPopup(true);
                          }
                          else{
                            customToastrAction.setNormalToastr(`${t('compare_candidate:scorecard_not_available')} ${candidate.candidate_name}.`, 'warning');
                          }
                        }}>{`${candidate.notes}`} {t('compare_candidate:notes')}</h3>
                      )}
                  </div>
                  <div className = {`${CandidateStyle.CompareCandidates__OverallScoreCount}`} style={TabletWidth(data)}>
                      {data.score_hash.map((candidate, index) =>
                        <h3 className = {`${flexBasis} ${getScoreColor(candidate.overall_score, false)}`}>{candidate.overall_score || 'N/A'}</h3>
                      )}
                  </div>
              </div>
          </div>
       { data?.competencies?.length > 0 && !data.scorecard_private && <div className = {`${CandidateStyle.CompareCandidates__w100}`}>
          <div className = {`${CandidateStyle.CompareCandidates__Title}`}>
            <h2>{t('compare_candidate:competencies')}</h2>
          </div>
          <hr/>
        </div> }
        {!data.scorecard_private && data.competencies.map((competency, competency_index) => {
          return <div className = {`${CandidateStyle.CompareCandidates__w100}`}>
          <div className = {`${CandidateStyle.CompareCandidates__CandidateCompetencies} mt24`}>
            <div className = {`${CandidateStyle.CompareCandidates__LeftContent}`}>
                <div className = {`${CandidateStyle.CompareCandidates__CompetencyName}`}>
                {competency.job_competency_name.trim().length > 40 ? (
                <Tooltip className='SimpleTooltip' content={competency.job_competency_name} background= {'#00325A'} radius={20} padding = {10} placement = "top" fixed = {false} fontSize= "11px">
                <div className = {`Competencytooltipwidth150 tooltipwidthmb0`}>
                  <h3>{competency.job_competency_name}</h3>
                  </div>
                  </Tooltip>): <h3 className={`${CandidateStyle.LessThanForty}`}>{competency.job_competency_name}</h3>}
                </div>
                {competency.job_sub_competencies.map((subcompetency, subcompetency_index) => {
                  return <div className = {`${CandidateStyle.CompareCandidates__SubCompetency}`}>
                    {subcompetency.job_sub_competency_name.trim().length > 40 ? (
                      <Tooltip className='SimpleTooltip' content={subcompetency.job_sub_competency_name} background= {'#00325A'} radius={20} padding = {10} placement = "top" fixed = {false} fontSize= "11px">
                      <div className = {`Competencytooltipwidth150 tooltipwidthmb0`}>
                        <h3>{subcompetency.job_sub_competency_name}</h3>
                        </div>
                        </Tooltip>): <h3 className={`${CandidateStyle.LessThanForty}`}>{subcompetency.job_sub_competency_name}</h3>}
                  </div>
                })}
            </div>
            <div className = {`${CandidateStyle.CompareCandidates__RightContent} ${competency.job_sub_competencies.length > 0 ? ''  : CandidateStyle.CompareCandidates__CandidateCompetencyOnly}`}>
              <div className = {`${CandidateStyle.CompareCandidates__CompetencyCount}`} style={TabletWidth(data)}>
                  {data.score_hash.map((candidate, index) =>
                    <h3 className = {`${flexBasis} ${getScoreColor(candidate.score_hash.filter((x) => x.job_competency_id == competency.job_competency_id)[0]?.score, false)}`}>{candidate.score_hash.filter((x) => x.job_competency_id == competency.job_competency_id)[0]?.score || 'N/A'}</h3>
                  )}
              </div>
              {competency.job_sub_competencies.map((subcompetency, subcompetency_index) =>
                <div className = {`${CandidateStyle.CompareCandidates__SubCompetencyCount}`} style={TabletWidth(data)}>
                  {data.score_hash.map((candidate, index) => {
                  return <h3 className = {`${flexBasis} ${getScoreColor(candidate.score_hash.filter((x) => x.job_competency_id == competency.job_competency_id)[0]?.job_sub_competencies?.filter((y) => y.job_sub_competency_id == subcompetency.job_sub_competency_id)[0]?.score, true)}`}>{candidate.score_hash.filter((x) => x.job_competency_id == competency.job_competency_id)[0]?.job_sub_competencies?.filter((y) => y.job_sub_competency_id == subcompetency.job_sub_competency_id)[0]?.score || 'N/A'}</h3>
                  })}
                </div>
                )}
            </div>
          </div>
        </div>
        })
        }
      </motion.div>
      <SingleCandidateModal setButtonPopup={setButtonPopup}
                buttonPopup={buttonPopup}
                data={scorecardData}
            />
    </div>
    );
}
// CompareCandidates.layout = ClientDashboard;
// export default CompareCandidates;